import capitalize from 'lodash-es/capitalize';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { numeral } from '@holmescorp/numeral';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import { ScatterChart } from './scatter-chart';
import { scoreExam } from '../support/calc-cutscore';
import { improvePlugin } from '../support/improve-plugin';
import { strengthPlugin } from '../support/strength-plugin';
import css from '../css/cut-scores.m.css';
const modulesToRawscores = (modules, ditaroots) => {
    const rv = {};
    let totalcorrect = 0;
    ditaroots.forEach((root) => {
        rv[root] = modules[root].data.pointscorrect;
        totalcorrect += rv[root];
    });
    rv.score = totalcorrect;
    return rv;
};
const defaultLabels = (ditaroots) => {
    const rv = {};
    ditaroots.forEach((root) => {
        rv[root] = capitalize(root);
    });
    return rv;
};
const nlsSettings = createNlsMiddleware('settings');
const nlsQuiz = createNlsMiddleware('quiz');
const factory = create({ theme, nlsSettings, nlsQuiz }).properties();
export const CutScores = factory(({ properties, middleware: { theme, nlsSettings, nlsQuiz } }) => {
    const { modules, quizPattern } = properties();
    const settingsNls = nlsSettings();
    const settingsMsgs = settingsNls.messages;
    const { format: formatSm, messages: { cutscores = '{}', cutscore_labels, cutscore_roots = '[]', cutscore_quizpattern = '' } } = settingsNls;
    const { format } = nlsQuiz();
    const cutscoreStats = JSON.parse(cutscores);
    const roots = JSON.parse(cutscore_roots);
    const cutscoreLabels = cutscore_labels ? JSON.parse(cutscore_labels) : defaultLabels(roots);
    const rawscores = modulesToRawscores(modules, roots);
    const scoring = scoreExam(cutscore_quizpattern ? cutscore_quizpattern : quizPattern, rawscores, roots, cutscoreStats);
    const data = [];
    const labels = [];
    const instructions = format && format('cutscore_instructions', { score: scoring.scaled });
    roots.forEach((root, idx) => {
        labels.push(`${idx}`);
        data.push({ y: idx, x: numeral(scoring[root]).format('0.000') });
    });
    const scales = {
        xAxes: [
            {
                type: 'linear',
                ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 6,
                    step: 1,
                    callback: ((v) => {
                        if (v === 3) {
                            return '';
                        }
                        return null;
                    })
                },
                scaleLabel: { display: false },
                gridLines: {
                    display: true,
                    drawBorder: true,
                    drawOnChartArea: true,
                    drawTicks: false,
                    borderDash: [8, 5],
                    color: '#000'
                }
            }
        ],
        yAxes: [
            {
                type: 'linear',
                ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 5,
                    callback: (v) => {
                        return cutscoreLabels[roots[v]];
                    }
                }
            }
        ]
    };
    const chartLabel = formatSm && formatSm('cutscore_widget_label', { association: settingsMsgs[`path-${quizPattern}`] });
    const chartprops = {
        ariaLabel: chartLabel,
        pluginCode: [improvePlugin, strengthPlugin],
        legend: { display: false, position: 'bottom' },
        options: {
            scales,
            tooltips: { enabled: false },
            elements: {
                point: {
                    pointStyle: 'rectRot'
                }
            },
            layout: {
                padding: {
                    left: 0,
                    right: 16,
                    top: 16,
                    bottom: 16
                }
            },
            plugins: {
                colorschemes: {
                    scheme: 'tableau.ColorBlind10'
                },
                improvearea: {
                    label: {
                        enabled: true,
                        text: 'Areas to Improve',
                        strokeColor: '#222222',
                        fontSize: 14,
                        fontStyle: 'bold'
                    }
                },
                strengtharea: {
                    label: {
                        enabled: true,
                        text: 'Areas of Strength',
                        strokeColor: '#222222',
                        fontSize: 14,
                        fontStyle: 'bold'
                    }
                }
            }
        },
        data: {
            datasets: [
                {
                    label: 'scores',
                    data,
                    fill: false,
                    backgroundColor: 'rgb(64, 103, 197)',
                    borderColor: 'rgb(0, 83, 193)',
                    borderWidth: 1,
                    pointRadius: 10
                }
            ]
        }
    };
    const themeCss = theme.classes(css);
    return v('div', {}, [
        v('div', { innerHTML: instructions }),
        v('div', { classes: [themeCss.root] }, [w(ScatterChart, chartprops)])
    ]);
});
